var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 15H14C11.2386 15 9 17.2386 9 20V58C9 60.7614 11.2386 63 14 63H66C68.7614 63 71 60.7614 71 58V20C71 17.2386 68.7614 15 66 15Z",
    fill: "white",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 28H14.5C13.6716 28 13 28.6716 13 29.5C13 30.3284 13.6716 31 14.5 31H28.5C29.3284 31 30 30.3284 30 29.5C30 28.6716 29.3284 28 28.5 28Z",
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 42H14.5C13.6716 42 13 42.6716 13 43.5C13 44.3284 13.6716 45 14.5 45H18.5C19.3284 45 20 44.3284 20 43.5C20 42.6716 19.3284 42 18.5 42Z",
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 42H23.5C22.6716 42 22 42.6716 22 43.5C22 44.3284 22.6716 45 23.5 45H35.5C36.3284 45 37 44.3284 37 43.5C37 42.6716 36.3284 42 35.5 42Z",
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 35H14.5C13.6716 35 13 35.6716 13 36.5C13 37.3284 13.6716 38 14.5 38H55.5C56.3284 38 57 37.3284 57 36.5C57 35.6716 56.3284 35 55.5 35Z",
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 49H14.5C13.6716 49 13 49.6716 13 50.5C13 51.3284 13.6716 52 14.5 52H46.5C47.3284 52 48 51.3284 48 50.5C48 49.6716 47.3284 49 46.5 49Z",
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 22.5H70.5",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6872 45.1033L62.451 40.1025L44.7848 62.1332L45.0678 62.36L42.2822 72.2489L51.7459 66.7266L51.5002 66.5365L68.6872 45.1033Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6872 45.1033L62.451 40.1025L44.7848 62.1332L45.0678 62.36L42.2822 72.2489L51.7459 66.7266L51.5002 66.5365L68.6872 45.1033Z",
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0441 43.7521L63.7743 40.3675C63.0453 39.7948 61.9518 39.8989 61.3791 40.6279L60.5459 41.7214L43.7793 62.8099C43.6751 62.914 43.6751 63.0702 43.6751 63.2264L41.0195 72.7553C40.9675 72.9636 41.0195 73.1719 41.1757 73.3281C41.2799 73.3802 41.384 73.4323 41.4882 73.4323C41.5923 73.4323 41.6444 73.4322 41.7485 73.3802L50.2881 68.5376C50.4443 68.5376 50.5484 68.4856 50.6526 68.3293L52.0585 66.611L53.8289 64.372L65.5968 49.584L67.4192 47.345L68.2524 46.2515C68.5127 45.887 68.6689 45.4704 68.6168 45.0018C68.6168 44.429 68.4086 44.0125 68.0441 43.7521ZM65.1802 48.4384L59.869 44.2207L61.0146 42.7628L66.3258 46.9805L65.1802 48.4384ZM53.4123 63.2264L48.1011 59.0087L59.2442 45.0539L64.5554 49.2716L53.4123 63.2264ZM51.6419 65.5175L46.3307 61.2998L47.4763 59.8419L52.7874 64.0596L51.6419 65.5175ZM42.3734 71.8181L44.5082 64.2679L49.1946 68.0169L42.3734 71.8181ZM50.1319 67.3921L44.8207 63.1744L45.6538 62.133L50.965 66.3507L50.1319 67.3921ZM67.5234 45.4704L67.0027 46.1474L61.6915 41.9817L62.2122 41.3048C62.4205 41.0444 62.837 40.9924 63.1495 41.2007L67.4192 44.5852C67.5754 44.6894 67.6275 44.8456 67.6796 45.0018C67.6796 45.2101 67.6275 45.3663 67.5234 45.4704Z",
    fill: "#BDBDBD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmpty);
export default __webpack_public_path__ + "static/media/ic-empty.a719d3b9d58bee2bd710e1d3e6408909.svg";
export { ForwardRef as ReactComponent };